var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { isValidSpacingToken } from '../../utilities/isValidSpacingToken';
export var CardWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  border-radius: 4px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  overflow: ", ";\n  padding: ", ";\n\n  .match-height {\n    height: 100%;\n  }\n"], ["\n  display: block;\n  width: 100%;\n  border-radius: 4px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  overflow: ", ";\n  padding: ", ";\n\n  .match-height {\n    height: 100%;\n  }\n"])), function (props) {
  return props.theme.tokens.space.surface.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.neutral.light;
}, function (_a) {
  var overflow = _a.overflow;
  return overflow;
}, function (_a) {
  var padding = _a.padding,
    theme = _a.theme;
  if (!padding) return '0';
  if (isValidSpacingToken(theme, padding)) return theme.tokens.spacing[padding];
  if (!isNaN(Number(padding))) return "".concat(padding, "px");
  return padding;
});
var templateObject_1;